export default
{
    PARLI: {
        characteristics: [
            {title: 'Persuasion', key: "per", tip: "Connection to the audience to build credibility?"},
            {title: 'Organization', key: "org", tip: "Easy to flow, follow, or take notes"},
            {title: 'Delivery', key: "del", tip: "The ability to effectively communicate verbally and nonverbally"},
            {title: 'Content/Support', key: "evi", tip: "Presents a compelling case/argument on sound logic and/or evidence"},
            {title: 'Point of Information', key: "poi", tip: "The process of asking and answering questions from opposing speakers"},
            {title: 'Refutation', key: "ref", tip: "The ability/attempt to demonstrate the error or inadequacy of the opposing arguments or ideas"},                        
        ],    
        roles: [
            ['gov', 'Government'],
            ['opp', 'Opposition'],
        ],
        needsDecision: true,
        renderer: require("./pageLayout_twoSidedDecision").renderer
    },
    TP: {
        characteristics: [
            {title: 'Persuasion', key: "per", tip: "Arguments are clear and compelling"},
            {title: 'Organization', key: "org", tip: "Logical flow of arguments and evidence"},
            {title: 'Delivery', key: "del", tip: "Confident, courteous, no distracting habits"},
            {title: 'Support', key: "evi", tip: "Evidence, examples & logic support arguments"},
            {title: 'Cross Examination', key: "cro", tip: "Courteous, probing, and compelling"},
            {title: 'Refutation', key: "ref", tip: "Responds to arguments with persuasive rebuttals"},                
        ],    
        roles: [
            ['aff', 'Affirmative'],
            ['neg', 'Negative'],
        ],
        needsDecision: true,
        renderer: require("./pageLayout_twoSidedDecision").renderer
    },
    TP26: {
        characteristics: [
            {title: 'Constructive Speech', key: "cs"},
            {title: 'Cross-Examination', key: "cx"},
            {title: 'Rebuttal Speech', key: "rs"},
            {title: 'Evidence', key: "evi"},
            {title: 'Organization', key: "org"},
            {title: 'Delivery', key: "del"},
        ],    
        roles: [
            ['aff', 'Affirmative'],
            ['neg', 'Negative'],
        ],
        needsDecision: true,
        renderer: require("./pageLayout_twoSidedDecision").renderer
    },
    STOA_TP: {
        characteristics: [
            {title: 'Persuasion', key: "per", tip: "Connection to the audience to build credibility?"},
            {title: 'Organization', key: "org", tip: "Easy to flow, follow, or take notes"},
            {title: 'Delivery', key: "del", tip: "The ability to effectively communicate verbally and nonverbally"},
            {title: 'Content/Support', key: "evi", tip: "Presents a compelling case/argument on sound logic and/or evidence"},
            {title: 'Cross X', key: "cro", tip: "The process of asking and answering questions from opposing speakers"},
            {title: 'Refutation', key: "ref", tip: "The ability/attempt to demonstrate the error or inadequacy of the opposing arguments or ideas"},                        
        ],    
        roles: [
            ['aff', 'Affirmative'],
            ['neg', 'Negative'],
        ],
        needsDecision: true,
        renderer: require("./pageLayout_twoSidedDecision").renderer
    },
    NCFCA_TP: {
        characteristics: [
            {title: 'Persuasion', key: "per", tip: "Connection to the audience to build credibility?"},
            {title: 'Organization', key: "org", tip: "Easy to flow, follow, or take notes"},
            {title: 'Delivery', key: "del", tip: "The ability to effectively communicate verbally and nonverbally"},
            {title: 'Content/Support', key: "evi", tip: "Presents a compelling case/argument on sound logic and/or evidence"},
            {title: 'Cross X', key: "cro", tip: "The process of asking and answering questions from opposing speakers"},
            {title: 'Refutation', key: "ref", tip: "The ability/attempt to demonstrate the error or inadequacy of the opposing arguments or ideas"},                        
        ],    
        roles: [
            ['aff', 'Affirmative'],
            ['neg', 'Negative'],
        ],
        needsDecision: true,
        renderer: require("./pageLayout_twoSidedDecision").renderer
    },
    LD: {
        characteristics: [
            {title: 'Persuasion', key: "per", tip: "Arguments are clear and compelling"},
            {title: 'Organization', key: "org", tip: "Logical flow of arguments and evidence"},
            {title: 'Delivery', key: "del", tip: "Confident, courteous, no distracting habits"},
            {title: 'Support', key: "evi", tip: "Evidence, examples & logic support arguments"},
            {title: 'Cross Examination', key: "cro", tip: "Courteous, probing, and compelling"},
            {title: 'Refutation', key: "ref", tip: "Responds to arguments with persuasive rebuttals"},                             
        ],    
        roles: [
            ['aff', 'Affirmative'],
            ['neg', 'Negative'],
        ],
        needsDecision: true,
        renderer: require("./pageLayout_twoSidedDecision").renderer
    },
    LD26: {
        characteristics: [
            {title: 'Constructive Speech', key: "cs"},
            {title: 'Cross-Examination', key: "cx"},
            {title: 'Rebuttal Speech', key: "rs"},
            {title: 'Evidence', key: "evi"},
            {title: 'Organization', key: "org"},
            {title: 'Delivery', key: "del"},
        ],    
        roles: [
            ['aff', 'Affirmative'],
            ['neg', 'Negative'],
        ],
        needsDecision: true,
        renderer: require("./pageLayout_twoSidedDecision").renderer
    },
    STOA_LD: {
        characteristics: [
            {title: 'Persuasion', key: "per", tip: "Connection to the audience to build credibility?"},
            {title: 'Organization', key: "org", tip: "Easy to flow, follow, or take notes"},
            {title: 'Delivery', key: "del", tip: "The ability to effectively communicate verbally and nonverbally"},
            {title: 'Content/Support', key: "evi", tip: "Presents a compelling case/argument on sound logic and/or evidence"},
            {title: 'Cross X', key: "cro", tip: "The process of asking and answering questions from opposing speakers"},
            {title: 'Refutation', key: "ref", tip: "The ability/attempt to demonstrate the error or inadequacy of the opposing arguments or ideas"},                        
        ],    
        roles: [
            ['aff', 'Affirmative'],
            ['neg', 'Negative'],
        ],
        needsDecision: true,
        renderer: require("./pageLayout_twoSidedDecision").renderer
    },
    NCFCA_LD: {
        characteristics: [
            {title: 'Persuasion', key: "per", tip: "Connection to the audience to build credibility?"},
            {title: 'Organization', key: "org", tip: "Easy to flow, follow, or take notes"},
            {title: 'Delivery', key: "del", tip: "The ability to effectively communicate verbally and nonverbally"},
            {title: 'Content/Support', key: "evi", tip: "Presents a compelling case/argument on sound logic and/or evidence"},
            {title: 'Cross X', key: "cro", tip: "The process of asking and answering questions from opposing speakers"},
            {title: 'Refutation', key: "ref", tip: "The ability/attempt to demonstrate the error or inadequacy of the opposing arguments or ideas"},                        
        ],    
        roles: [
            ['aff', 'Affirmative'],
            ['neg', 'Negative'],
        ],
        needsDecision: true,
        renderer: require("./pageLayout_twoSidedDecision").renderer
    },
    AD: {
        characteristics: [
            {title: 'Content', key: "con", tip: "The totality of the material within the speech"},
            {title: 'Delivery', key: "del", tip: "The manner in which the speech is delivered both vocally and physically"},
            {title: 'Structure/Organization', key: "org", tip: "The flow of the speech, and how it is put together"},
            {title: 'Lasting Impact', key: "imp", tip: "The residual impact. The takeaway. Does the speech leave you with something you didn't have before?"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_individual").renderer
    },
    BIO: {
        characteristics: [
            {title: 'Content', key: "con", tip: "The totality of the material within the speech"},
            {title: 'Delivery', key: "del", tip: "The manner in which the speech is delivered both vocally and physically"},
            {title: 'Structure/Organization', key: "org", tip: "The flow of the speech, and how it is put together"},
            {title: 'Lasting Impact', key: "imp", tip: "The residual impact. The takeaway. Does the speech leave you with something you didn't have before?"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_individual").renderer
    },
    VP: {
        characteristics: [
            {title: 'Content', key: "con", tip: "The totality of the material within the speech"},
            {title: 'Delivery', key: "del", tip: "The manner in which the speech is delivered both vocally and physically"},
            {title: 'Structure/Organization', key: "org", tip: "The flow of the speech, and how it is put together"},
            {title: 'Lasting Impact', key: "imp", tip: "The residual impact. The takeaway. Does the speech leave you with something you didn't have before?"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_individual").renderer
    },
    OE: {
        characteristics: [
            {title: 'Content', key: "con", tip: "The totality of the material within the speech"},
            {title: 'Delivery', key: "del", tip: "The manner in which the speech is delivered both vocally and physically"},
            {title: 'Structure/Organization', key: "org", tip: "The flow of the speech, and how it is put together"},
            {title: 'Lasting Impact', key: "imp", tip: "The residual impact. The takeaway. Does the speech leave you with something you didn't have before?"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_individual").renderer
    },
    OO: {
        characteristics: [
            {group: 'Content', key: "ga0"},
            {groupKey: 'ga0', title: 'Organized in a way that supports the message and is easy to follow', key: "ga1"},
            {groupKey: 'ga0', title: 'Appropriate for the audience and the speaker in maturity and subject', key: "ga2"},
            {groupKey: 'ga0', title: 'Well-researched and/ or thought-provoking', key: "ga3"},
            {groupKey: 'ga0', title: 'Verbal mention of sources', key: "ga4"},
            {group: 'Delivery', key: "gb0"},
            {groupKey: 'gb0', title: 'Correct and comfortable in volume, clarity of speech, pronunciation, diction', key: "gb1"},
            {groupKey: 'gb0', title: 'Animated with a variety of tone, inflection, accent, volume', key: "gb2"},
            {groupKey: 'gb0', title: 'Good eye contact, meaningful facial expressions, free from distracting filler words', key: "gb3"},
            {groupKey: 'gb0', title: 'Creative use of stage, meaningful gestures, free from distracting habits', key: "gb4"},
            {group: 'Impact', key: "gc0"},
            {groupKey: 'gc0', title: 'Communicates the relevance of the message', key: "gc1"},
            {groupKey: 'gc0', title: 'Establishes a rapport with the judge', key: "gc2"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_groupedIndividual").renderer
    },
    DP: {
        characteristics: [
            {group: 'Main Idea', key: "ga0"},
            {groupKey: 'ga0', title: 'Importance or interest level of topic', key: "ga1"},
            {groupKey: 'ga0', title: 'Reference to main idea or thesis throughout speech', key: "ga2"},
            {groupKey: 'ga0', title: 'Thesis supported by logic, research or stories', key: "ga3"},
            {group: 'Language and Visual', key: "gb0"},
            {groupKey: 'gb0', title: 'Speech organization, intro and conclusion ', key: "gb1"},
            {groupKey: 'gb0', title: 'Use of transitions and literary devices', key: "gb2"},
            {groupKey: 'gb0', title: 'Effectiveness and appeal of slides', key: "gb3"},
            {groupKey: 'gb0', title: 'Use of time to balance assertions', key: "gb4"},
            {group: 'Voice', key: "gc0"},
            {groupKey: 'gc0', title: 'Ability to hear and understand speaker', key: "gc1"},
            {groupKey: 'gc0', title: 'Accuracy of pronunciation', key: "gc2"},
            {groupKey: 'gc0', title: 'Use of volume, rate, pitch, etc.', key: "gc3"},
            {groupKey: 'gc0', title: 'Ability to be sincere and conversational', key: "gc4"},
            {group: 'Action', key: "gd0"},
            {groupKey: 'gd0', title: 'Posture, use of hands and body language', key: "gd1"},
            {groupKey: 'gd0', title: 'Eye contact, facial expressions, gestures', key: "gd2"},
            {groupKey: 'gd0', title: 'Interaction with slides', key: "gd3"},
            {groupKey: 'gd0', title: 'Use of stage and management of equipment', key: "gd4"},
            {group: 'Impact', key: "ge0"},
            {groupKey: 'ge0', title: 'Ability to use tact with opinion topics if applicable', key: "ge1"},
            {groupKey: 'ge0', title: 'Use of humor, sympathy or other feelings', key: "ge2"},
            {groupKey: 'ge0', title: 'Development of rapport with audience', key: "ge3"},
            {groupKey: 'ge0', title: 'Alignment with ASDA mission', key: "ge4"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_groupedIndividual").renderer
    },
    INFO: {
        characteristics: [
            {title: 'Content', key: "con", tip: "The totality of the material within the speech"},
            {title: 'Delivery', key: "del", tip: "The manner in which the speech is delivered both vocally and physically"},
            {title: 'Structure/Organization', key: "org", tip: "The flow of the speech, and how it is put together"},
            {title: 'Lasting Impact', key: "imp", tip: "The residual impact. The takeaway. Does the speech leave you with something you didn't have before?"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_individual").renderer
    },
    OPEN: {
        characteristics: [
            {group: 'Content', key: "ga0"},
            {groupKey: 'ga0', title: 'Organized in a way that supports the message and is easy to follow', key: "ga1"},
            {groupKey: 'ga0', title: 'Appropriate for the audience and the speaker in maturity and subject', key: "ga2"},
            {groupKey: 'ga0', title: 'Story lines are relevant to the message and told in an engaging way', key: "ga3"},
            {groupKey: 'ga0', title: 'The speech resolves a concern or addresses a character’s struggle', key: "ga4"},
            {group: 'Delivery', key: "gb0"},
            {groupKey: 'gb0', title: 'Correct and comfortable in volume, clarity of speech, pronunciation, diction', key: "gb1"},
            {groupKey: 'gb0', title: 'Animated with a variety of tone, inflection, accent, volume', key: "gb2"},
            {groupKey: 'gb0', title: 'Creative use of stage, meaningful scene portrayal', key: "gb3"},
            {groupKey: 'gb0', title: 'Distinct, realistic, relatable character voices, mannerisms, and posture', key: "gb4"},
            {group: 'Impact', key: "gc0"},
            {groupKey: 'gc0', title: 'Communicates the relevance of the message', key: "gc1"},
            {groupKey: 'gc0', title: 'Establishes a rapport with the judge', key: "gc2"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_groupedIndividual").renderer
    },
    HI: {
        characteristics: [
            {title: 'Content', key: "con", tip: "The totality of the material within the speech"},
            {title: 'Delivery', key: "del", tip: "Characterization and Blocking - Develops rich characters and vivid scenes for the selection"},
            {title: 'Structure/Organization', key: "org", tip: "The flow of the speech, and how it is put together"},
            {title: 'Lasting Impact', key: "imp", tip: "The residual impact. The takeaway. Does the speech leave you with something you didn't have before?"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_individual").renderer
    },
    DUO: {
        characteristics: [
            {group: 'Content', key: "ga0"},
            {groupKey: 'ga0', title: 'Organized in a way that supports the message and is easy to follow', key: "ga1"},
            {groupKey: 'ga0', title: 'Appropriate for the audience and the speaker in maturity and subject', key: "ga2"},
            {groupKey: 'ga0', title: 'Story lines are relevant to the message and told in an engaging way', key: "ga3"},
            {groupKey: 'ga0', title: 'The speech resolves a concern or addresses a character’s struggle', key: "ga4"},
            {group: 'Delivery', key: "gb0"},
            {groupKey: 'gb0', title: 'Correct and comfortable in volume, clarity of speech, pronunciation, diction', key: "gb1"},
            {groupKey: 'gb0', title: 'Animated with a variety of tone, inflection, accent, volume', key: "gb2"},
            {groupKey: 'gb0', title: 'Creative use of stage, meaningful scene portrayal', key: "gb3"},
            {groupKey: 'gb0', title: 'Distinct, realistic, relatable character voices, mannerisms, and posture', key: "gb4"},
            {groupKey: 'gb0', title: 'The two competitors must not intentionally touch or make eye contact with each other', key: "gb5"},
            {group: 'Impact', key: "gc0"},
            {groupKey: 'gc0', title: 'Communicates the relevance of the message', key: "gc1"},
            {groupKey: 'gc0', title: 'Establishes a rapport with the judge', key: "gc2"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_groupedDuo").renderer
    },
    PER: {
        characteristics: [
            {title: 'Content', key: "con", tip: "The totality of the material within the speech"},
            {title: 'Delivery', key: "del", tip: "The manner in which the speech is delivered both vocally and physically"},
            {title: 'Structure/Organization', key: "org", tip: "The flow of the speech, and how it is put together"},
            {title: 'Lasting Impact', key: "imp", tip: "The residual impact. The takeaway. Does the speech leave you with something you didn't have before?"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_individual").renderer
    },
    BT: {
        characteristics: [
            {title: 'Content', key: "con", tip: "The totality of the material within the speech"},
            {title: 'Delivery', key: "del", tip: "The manner in which the speech is delivered both vocally and physically"},
            {title: 'Structure/Organization', key: "org", tip: "The flow of the speech, and how it is put together"},
            {title: 'Lasting Impact', key: "imp", tip: "The residual impact. The takeaway. Does the speech leave you with something you didn't have before?"},
            {title: 'Binder Work', key: "bin", tip: "Effectively and creatively uses the binder and it's content throughout the speech"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_individual").renderer
    },
    STOA_APOL: {
        characteristics: [
            {group: 'Content', key: "ga0"},
            {groupKey: 'ga0', title: 'Answers', key: "ga1", tip: "Answers and analyzes the specific topic chosen"},
            {groupKey: 'ga0', title: 'Defense', key: "ga2", tip: "Provides researched defense of Biblical truth for selected topic"},
            {groupKey: 'ga0', title: 'Explains', key: "ga3", tip: "Explains the background of the topic"},
            {groupKey: 'ga0', title: 'Demonstrates', key: "ga4", tip: "Demonstrates the importance of the topic"},
            {groupKey: 'ga0', title: 'Support', key: "ga5", tip: "Uses Scripture and other supporting sources"},
            {groupKey: 'ga0', title: 'Illustrations', key: "ga6", tip: "Includes relevant illustrations or personal examples"},
            {group: 'Organization', key: "gb0"},
            {groupKey: 'gb0', title: 'Introduction', key: "gb1", tip: "Relevant and engaging introduction"},
            {groupKey: 'gb0', title: 'Body', key: "gb2", tip: "Cohesive body of thought with smooth transistions"},
            {groupKey: 'gb0', title: 'Conclusion', key: "gb3", tip: "Conclusion promotes reflection"},   
            {group: 'Rhetoric', key: "gc0"},
            {groupKey: 'gc0', title: 'Audience', key: "gc1", tip: "Addresses an audience that may or may not accept the Bible as truth"},
            {groupKey: 'gc0', title: 'Credibility', key: "gc2", tip: "Credible and sincere connection wiht audience"},
            {groupKey: 'gc0', title: 'Persuasiveness', key: "gc3", tip: "Compelling and persuasive"},
            {groupKey: 'gc0', title: 'Connection', key: "gc4", tip: "Winsome and compelling"},
            {group: 'Delivery', key: "gd0"},
            {groupKey: 'gd0', title: 'Conversational', key: "gd1", tip: "Conversational style"},
            {groupKey: 'gd0', title: 'Dynamics', key: "gd2", tip: "Varies voulume, reate, and inflection"},
            {groupKey: 'gd0', title: 'Eye Contact', key: "gd3", tip: "Eye Contact"},
            {groupKey: 'gd0', title: 'Physicality', key: "gd4", tip: "Authentic gestures and movements"},
            {group: 'Overall Impression', key: "ge0"},
            {groupKey: 'ge0', title: 'Professionalism', key: "ge1", tip: "Demonstrates professionalism"},
            {groupKey: 'ge0', title: 'Effectiveness', key: "ge2", tip: "Total effectiveness"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_groupedIndividual").renderer
    },
    APOL1: {
        characteristics: [
            {group: 'Content', key: "ga0"},
            {groupKey: 'ga0', title: 'Answers', key: "ga1", tip: "Answers and analyzes the specific topic chosen"},
            {groupKey: 'ga0', title: 'Defense', key: "ga2", tip: "Provides researched defense of Biblical truth for selected topic"},
            {groupKey: 'ga0', title: 'Explains', key: "ga3", tip: "Explains the background of the topic"},
            {groupKey: 'ga0', title: 'Demonstrates', key: "ga4", tip: "Demonstrates the importance of the topic"},
            {groupKey: 'ga0', title: 'Support', key: "ga5", tip: "Uses Scripture and other supporting sources"},
            {groupKey: 'ga0', title: 'Illustrations', key: "ga6", tip: "Includes relevant illustrations or personal examples"},
            {group: 'Organization', key: "gb0"},
            {groupKey: 'gb0', title: 'Introduction', key: "gb1", tip: "Relevant and engaging introduction"},
            {groupKey: 'gb0', title: 'Body', key: "gb2", tip: "Cohesive body of thought with smooth transistions"},
            {groupKey: 'gb0', title: 'Conclusion', key: "gb3", tip: "Conclusion promotes reflection"},   
            {group: 'Rhetoric', key: "gc0"},
            {groupKey: 'gc0', title: 'Audience', key: "gc1", tip: "Addresses an audience that may or may not accept the Bible as truth"},
            {groupKey: 'gc0', title: 'Credibility', key: "gc2", tip: "Credible and sincere connection wiht audience"},
            {groupKey: 'gc0', title: 'Persuasiveness', key: "gc3", tip: "Compelling and persuasive"},
            {groupKey: 'gc0', title: 'Connection', key: "gc4", tip: "Winsome and compelling"},
            {group: 'Delivery', key: "gd0"},
            {groupKey: 'gd0', title: 'Conversational', key: "gd1", tip: "Conversational style"},
            {groupKey: 'gd0', title: 'Dynamics', key: "gd2", tip: "Varies voulume, reate, and inflection"},
            {groupKey: 'gd0', title: 'Eye Contact', key: "gd3", tip: "Eye Contact"},
            {groupKey: 'gd0', title: 'Physicality', key: "gd4", tip: "Authentic gestures and movements"},
            {group: 'Overall Impression', key: "ge0"},
            {groupKey: 'ge0', title: 'Professionalism', key: "ge1", tip: "Demonstrates professionalism"},
            {groupKey: 'ge0', title: 'Effectiveness', key: "ge2", tip: "Total effectiveness"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_groupedIndividual").renderer
    },
    APOL: {
        characteristics: [
            {title: 'Content', key: "con", tip: "The totality of the material within the speech"},
            {title: 'Delivery', key: "del", tip: "The manner in which the speech is delivered both vocally and physically"},
            {title: 'Structure/Organization', key: "org", tip: "The flow of the speech, and how it is put together"},
            {title: 'Lasting Impact', key: "imp", tip: "The residual impact. The takeaway. Does the speech leave you with something you didn't have before?"},
            {title: 'Sources', key: "sou", tip: "Adds support effectively through scripture, assertions, or examples when necessary"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_individual").renderer
    },
    IS: {
        characteristics: [
            {group: 'Content', key: "ga0"},
            {groupKey: 'ga0', title: 'Organized in a way that supports the message and is easy to follow', key: "ga1"},
            {groupKey: 'ga0', title: 'Appropriate for the audience and the speaker in maturity and subject', key: "ga2"},
            {groupKey: 'ga0', title: 'Verbal mention of sources', key: "ga4"},
            {group: 'Delivery', key: "gb0"},
            {groupKey: 'gb0', title: 'Correct and comfortable in volume, clarity of speech, pronunciation, diction', key: "gb1"},
            {groupKey: 'gb0', title: 'Animated with a variety of tone, inflection, accent, volume', key: "gb2"},
            {groupKey: 'gb0', title: 'Good eye contact, meaningful facial expressions, free from distracting filler words', key: "gb3"},
            {groupKey: 'gb0', title: 'Creative use of stage, meaningful gestures, free from distracting habits', key: "gb4"},
            {group: 'Impact', key: "gc0"},
            {groupKey: 'gc0', title: 'Communicates the relevance of the message', key: "gc1"},
            {groupKey: 'gc0', title: 'Establishes a rapport with the judge', key: "gc2"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_groupedIndividual").renderer
    },
    ES: {
        characteristics: [
            {group: 'Content', key: "ga0"},
            {groupKey: 'ga0', title: 'Organized in a way that supports the message and is easy to follow', key: "ga1"},
            {groupKey: 'ga0', title: 'Appropriate for the audience and the speaker in maturity and subject', key: "ga2"},
            {groupKey: 'ga0', title: 'Well-researched and/ or thought-provoking', key: "ga3"},
            {groupKey: 'ga0', title: 'Verbal mention of sources', key: "ga4"},
            {group: 'Delivery', key: "gb0"},
            {groupKey: 'gb0', title: 'Correct and comfortable in volume, clarity of speech, pronunciation, diction', key: "gb1"},
            {groupKey: 'gb0', title: 'Animated with a variety of tone, inflection, accent, volume', key: "gb2"},
            {groupKey: 'gb0', title: 'Good eye contact, meaningful facial expressions, free from distracting filler words', key: "gb3"},
            {groupKey: 'gb0', title: 'Creative use of stage, meaningful gestures, free from distracting habits', key: "gb4"},
            {group: 'Impact', key: "gc0"},
            {groupKey: 'gc0', title: 'Communicates the relevance of the message', key: "gc1"},
            {groupKey: 'gc0', title: 'Establishes a rapport with the judge', key: "gc2"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_groupedIndividual").renderer
    },
    VFO: {
        characteristics: [
            {group: 'Content', key: "ga0"},
            {groupKey: 'ga0', title: 'Organized in a way that supports the message and is easy to follow', key: "ga1"},
            {groupKey: 'ga0', title: 'Appropriate for the audience and the speaker in maturity and subject', key: "ga2"},
            {groupKey: 'ga0', title: 'Well-researched and/ or thought-provoking', key: "ga3"},
            {groupKey: 'ga0', title: 'Verbal mention of sources', key: "ga4"},
            {group: 'Delivery', key: "gb0"},
            {groupKey: 'gb0', title: 'Correct and comfortable in volume, clarity of speech, pronunciation, diction', key: "gb1"},
            {groupKey: 'gb0', title: 'Animated with a variety of tone, inflection, accent, volume', key: "gb2"},
            {groupKey: 'gb0', title: 'Good eye contact, meaningful facial expressions, free from distracting filler words', key: "gb3"},
            {groupKey: 'gb0', title: 'Creative use of stage, meaningful gestures, free from distracting habits', key: "gb4"},
            {group: 'Impact', key: "gc0"},
            {groupKey: 'gc0', title: 'Communicates the relevance of the message', key: "gc1"},
            {groupKey: 'gc0', title: 'Establishes a rapport with the judge', key: "gc2"},
            {groupKey: 'gc0', title: 'Focuses on a personal value or belief of the competitor', key: "gc3"},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_groupedIndividual").renderer
    },
    BV: {
        characteristics: [
            {title: 'Topic', key: 'topic', render: false},
            {title: 'Main Idea', key: "mi0", instruction: "What is interesting or important about the main idea? You might comment on:", bullets: [
                'Importance or interest level of response to the prompt',
                'Reference to main idea or thesis throughout speech',
                'Thesis supported by appeals to authority or other research',
                'Understanding of topic as indicated through speech development',
            ]},
            {title: 'Language', key: "lang0", instruction: "How did the use of language enhance the speech? You might comment on:", bullets: [
                'Speech organization, intro and conclusion',
                'Integration of quotes, citations or paraphrasing from sources',
                'Use of transitions and literary devices',
                'Use of time to balance assertions',
            ]},
            {title: 'Voice', key: "voic0", instruction: "In what ways did the speaker’s voice capture your attention? You might comment on:", bullets: [
                'Ability to hear and understand speaker',
                'Accuracy of pronunciation',
                'Use of volume, rate, pitch, etc.',
                'Ability to be sincere and conversational',
            ]},
            {title: 'Action', key: "act0", instruction: "What made the speech interesting to watch? You might comment on:", bullets: [
                'Posture, use of hands and body language',
                'Eye contact, facial expressions, gestures',
                'Use of stage',
            ]},
            {title: 'Impact', key: "imp0", instruction: "Does the speech develop rapport and align with ASDA mission? You might comment on:", bullets: [
                'Ability to use tact with opinion topics if applicable',
                'Use of humor, sympathy or other feelings',
                'Development of rapport with audience',
                'Alignment with ASDA mission',
            ]},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_asdaSpeech26").renderer
    },
    DP26: {
        characteristics: [
            {title: 'Topic', key: 'topic', render: false},
            {title: 'Main Idea', key: "mi0", instruction: "What is interesting or important about the main idea? You might comment on:", bullets: [
                'Importance or interest level of topic',
                'Reference to main idea or thesis throughout speech',
                'Thesis supported by logic, research or stories',
            ]},
            {title: 'Language and Visual', key: "lang0", instruction: "How did the use of language and visual aids enhance the speech? You might comment on:", bullets: [
                'Speech organization, intro and conclusion',
                'Use of transitions and literary devices',
                'Effectiveness and appeal of slides',
                'Use of time to balance assertions',
            ]},
            {title: 'Voice', key: "voic0", instruction: "In what ways did the speaker’s voice capture your attention? You might comment on:", bullets: [
                'Ability to hear and understand speaker',
                'Accuracy of pronunciation',
                'Use of volume, rate, pitch, etc.',
                'Ability to be sincere and conversational',
            ]},
            {title: 'Action', key: "act0", instruction: "What made the speech interesting to watch? You might comment on:", bullets: [
                'Posture, use of hands and body language',
                'Eye contact, facial expressions, gestures',
                'Interaction with slides',
                'Use of stage and management of equipment',
            ]},
            {title: 'Impact', key: "imp0", instruction: "Does the speech develop rapport and align with ASDA mission? You might comment on:", bullets: [
                'Ability to use tact with opinion topics if applicable',
                'Use of humor, sympathy or other feelings',
                'Development of rapport with audience',
                'Alignment with ASDA mission',
            ]},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_asdaSpeech26").renderer
    },
    IS26: {
        characteristics: [
            {title: 'Topic', key: 'topic', render: false},
            {title: 'Main Idea', key: "mi0", instruction: "What is interesting or important about the main idea? You might comment on:", bullets: [
                'Importance or interest level of response to the prompt',
                'Reference to main idea or thesis throughout speech',
                'Stories from personal experience, history, literature, etc.',
                'Understanding of topic as indicated through speech development',
            ]},
            {title: 'Language', key: "lang0", instruction: "How did the use of language enhance the speech? You might comment on:", bullets: [
                'Speech organization, intro and conclusion',
                'Integration of stories',
                'Use of transitions and literary devices',
                'Use of time to balance assertions',
            ]},
            {title: 'Voice', key: "voic0", instruction: "In what ways did the speaker’s voice capture your attention? You might comment on:", bullets: [
                'Ability to hear and understand speaker',
                'Accuracy of pronunciation',
                'Use of volume, rate, pitch, etc.',
                'Ability to be sincere and conversational',
            ]},
            {title: 'Action', key: "act0", instruction: "What made the speech interesting to watch? You might comment on:", bullets: [
                'Posture, use of hands and body language',
                'Eye contact, facial expressions, gestures',
                'Use of stage',
            ]},
            {title: 'Impact', key: "imp0", instruction: "Does the speech develop rapport and align with ASDA mission? You might comment on:", bullets: [
                'Ability to use tact with opinion topics if applicable',
                'Use of humor, sympathy or other feelings',
                'Development of rapport with audience',
                'Alignment with ASDA mission',
            ]},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_asdaSpeech26").renderer
    },
    OPEN26: {
        characteristics: [
            {title: 'Topic', key: 'topic', render: false},
            {title: 'Main Idea', key: "mi0", instruction: "What is interesting or important about the main idea? You might comment on:", bullets: [
                'Theme appeals to wide audience and relevant over time',
                'Theme developed through humor or other emotion',
                'Interest level of literature selection',
            ]},
            {title: 'Script', key: "scr0", instruction: "How did the script enhance the speech? You might comment on:", bullets: [
                'Artful elements such as symbols, foreshadowing, imagery, etc.',
                'Rising action, conflict and resolution',
                'Choice of characters',
                'Ease of following the story line',
            ]},
            {title: 'Character Acting', key: "ca0", instruction: "In what ways did the speaker’s voice capture your attention? You might comment on:", bullets: [
                'Differentiation of characters through accent, volume, rate or pitch, etc.',
                'Believability of character bearing, mannerisms or facial expressions, etc.',
                'Transitions between characters',
                'Consistency of the portrayal of characters throughout',
            ]},
            {title: 'Scene Development', key: "sd0", instruction: "What made the speech interesting to watch? You might comment on:", bullets: [
                'Believability of scene development',
                'Staging',
                'Creation of imaginary props',
                'Transition between scenes',
            ]},
            {title: 'Impact', key: "imp0", instruction: "Does the speech develop rapport and align with ASDA mission? You might comment on:", bullets: [
                'Ability to use tact with opinion topics if applicable',
                'Use of humor, sympathy or other feelings',
                'Development of rapport with audience',
                'Alignment with ASDA mission',
            ]},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_asdaSpeech26").renderer
    },
    OO26: {
        characteristics: [
            {title: 'Topic', key: 'topic', render: false},
            {title: 'Duration', key: 'speechDurationSec', render: false},
            {title: 'Main Idea', key: "mi0", instruction: "What is interesting or important about the main idea? You might comment on:", bullets: [
                'Importance or interest level of topic',
                'Reference to main idea or thesis throughout speech',
                'Thesis supported by logic, research or stories',
                'Demonstration of depth of understanding',
            ]},
            {title: 'Language', key: "lang0", instruction: "How did the use of language enhance the speech? You might comment on:", bullets: [
                'Speech organization, intro and conclusion',
                'Use of transitions and literary devices',
                'Integration or stories, statistics or quotes',
                'Use of time to balance assertions',
            ]},
            {title: 'Voice', key: "voic0", instruction: "In what ways did the speaker’s voice capture your attention? You might comment on:", bullets: [
                'Ability to hear and understand speaker',
                'Accuracy of pronunciation',
                'Use of volume, rate, pitch, etc.',
                'Ability to be sincere and conversational',
            ]},
            {title: 'Action', key: "act0", instruction: "What made the speech interesting to watch? You might comment on:", bullets: [
                'Posture, use of hands and body language',
                'Eye contact, facial expressions, gestures',
                'Use of stage',
                'Memorization of speech',
            ]},
            {title: 'Impact', key: "imp0", instruction: "Does the speech develop rapport and align with ASDA mission? You might comment on:", bullets: [
                'Ability to use tact with opinion topics if applicable',
                'Use of humor, sympathy or other feelings',
                'Development of rapport with audience',
                'Alignment with ASDA mission',
            ]},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_asdaSpeech26").renderer
    },
    ES26: {
        characteristics: [
            {title: 'Topic', key: 'topic', render: false},
            {title: 'Main Idea', key: "mi0", instruction: "What is interesting or important about the main idea? You might comment on:", bullets: [
                'Importance or interest level of stance',
                'Reference to main idea or thesis throughout speech',
                'Thesis supported by logic, research or stories',
                'Depth of understanding as indicated through source use',
            ]},
            {title: 'Language', key: "lang0", instruction: "How did the use of language enhance the speech? You might comment on:", bullets: [
                'Speech organization, intro and conclusion',
                'Integration of quotes, citations or paraphrasing from sources',
                'Use of transitions and literary devices',
                'Use of time to balance assertions',
            ]},
            {title: 'Voice', key: "voic0", instruction: "In what ways did the speaker’s voice capture your attention? You might comment on:", bullets: [
                'Ability to hear and understand speaker',
                'Accuracy of pronunciation',
                'Use of volume, rate, pitch, etc.',
                'Ability to be sincere and conversational',
            ]},
            {title: 'Action', key: "act0", instruction: "What made the speech interesting to watch? You might comment on:", bullets: [
                'Posture, use of hands and body language',
                'Eye contact, facial expressions, gestures',
                'Use of stage',
            ]},
            {title: 'Impact', key: "imp0", instruction: "Does the speech develop rapport and align with ASDA mission? You might comment on:", bullets: [
                'Ability to use tact with opinion topics if applicable',
                'Use of humor, sympathy or other feelings',
                'Development of rapport with audience',
                'Alignment with ASDA mission',
            ]},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_asdaSpeech26").renderer
    },
    DUO26: {
        characteristics: [
            {title: 'Topic', key: 'topic', render: false},
            {title: 'Main Idea', key: "mi0", instruction: "What is interesting or important about the main idea? You might comment on:", bullets: [
                'Theme appeals to wide audience and relevant over time',
                'Theme developed through humor or other emotion',
                'Interest level of literature selection',
            ]},
            {title: 'Script', key: "scr0", instruction: "How did the script enhance the speech? You might comment on:", bullets: [
                'Artful elements such as symbols, foreshadowing, imagery, etc.',
                'Rising action, conflict and resolution',
                'Choice of characters',
                'Ease of following the story line',
            ]},
            {title: 'Character Acting', key: "ca0", instruction: "In what ways did the speaker’s voice capture your attention? You might comment on:", bullets: [
                'Differentiation of characters through accent, volume, rate or pitch, etc.',
                'Believability of character bearing, mannerisms or facial expressions, etc.',
                'Transitions between characters',
                'Consistency of the portrayal of characters throughout',
            ]},
            {title: 'Scene Development', key: "sd0", instruction: "What made the speech interesting to watch? You might comment on:", bullets: [
                'Balance of competitors’ participation',
                'Interaction between the two competitors',
                'Staging and creation of scenes',
                'Transition between scenes',
            ]},
            {title: 'Impact', key: "imp0", instruction: "Does the speech develop rapport and align with ASDA mission? You might comment on:", bullets: [
                'Ability to use tact with opinion topics if applicable',
                'Use of humor, sympathy or other feelings',
                'Development of rapport with audience',
                'Alignment with ASDA mission',
            ]},
        ],    
        roles: [
            ['spe', 'Speaker']
        ],
        needsDecision: false,
        renderer: require("./pageLayout_asdaSpeechDuo26").renderer
    },
}